import React from 'react';
import BaseComponent from '../../common/BaseComponent/BaseComponent';

import Social from './Social';
import FAQ from './FAQ';
import Contacts from './Contacts';
import PaymentWays from './PaymentWays';
import FooterDark from "./FooterDark";

import styles from './ComponentFooter.scss';
import {ContextDataStore} from "../../common/helpers/HelperGlobalDataStore";


class ComponentFooter extends BaseComponent {

	profile_url = '';

	constructor() {
		super(...arguments, 'ComponentFooter');
	}

	eventConsume(actionName, actionObject) {

		if (actionName === 'LazyLoadingComplete') {
			if (actionObject.componentName === 'ComponentMainNav') {
				this.profile_url = actionObject.componentData.profileLinkShort;
				this.setState(this.state);
			}
			if (actionObject.componentName === 'ComponentHeaderPublic') {
				this.profile_url = actionObject.componentData.mainNav.componentData.profileLinkShort;
				this.setState(this.state);
			}
		}

	}

	render() {

		const data = this.context.get('ComponentMainNav');

		if (data) {
			this.profile_url = data.componentData.profileLinkShort;
		}

		return (
		  <footer data-test="footer">
			  <div className={styles.container}>
				  <Social/>
				  <FAQ/>
				  <Contacts/>
				  <PaymentWays/>
			  </div>
			  <FooterDark profileURL={this.profile_url}/>
		  </footer>
		);
	}

}

// React Context binding
ComponentFooter.contextType = ContextDataStore;

export default ComponentFooter;